module.exports = __webpack_public_path__ + "img/fe562a6.png";